import { useToast } from '@televet/kibble-ui/Toast';

type ToastOptions = {
  title?: string;
  description?: string;
  duration?: number;
  closable?: boolean;
};

let toastInstance: ReturnType<typeof useToast> | null = null;

export const ToasterInitializer = () => {
  toastInstance = useToast('bottom');
  return null;
};

export const toaster = {
  success: (options: ToastOptions) => {
    toastInstance?.create({ ...options, status: 'success', closable: options.closable ?? true });
  },
  error: (options: ToastOptions) => {
    toastInstance?.create({ ...options, status: 'error', closable: options.closable ?? true });
  },
  info: (options: ToastOptions) => {
    toastInstance?.create({ ...options, status: 'info', closable: options.closable ?? true });
  },
  warning: (options: ToastOptions) => {
    toastInstance?.create({ ...options, status: 'warning', closable: options.closable ?? true });
  },
};
